import { AutoComplete, ConfigProvider, Select } from "antd";
import { userData } from "pages/Dashboard/AccountsOverview";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { mixGetV2 } from "services/mixin";

const CredentialsModal = ({ accountId, setIsShowModalCredentials }: {
    accountId: string;
    setIsShowModalCredentials: (value: boolean) => void;
}) => {
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [showPassworldChanger, setShowPassworldChanger] = useState(false);
    const [typeSelected, setTypeSelected] = useState<'master' | 'read-only'>('master');
    async function handleShowModalChangePassword(type: 'master' | 'read-only') {
        setShowPassworldChanger(true);
        setTypeSelected(type);
    }
    const { t } = useTranslation();
    async function onSave(newPassword: string) {
        const info = userData.find((user) => user.accountId === accountId);
        if (!info) {
            console.error('User not found');
            return;
        }
        if (typeSelected === 'master') {
            info.masterPassword = newPassword; // Replace with actual new password logic
        } else {
            info.readOnlyPassword = newPassword; // Replace with actual new password logic
        }
        setShowPassworldChanger(false);
    }
    const [userInfo, setUserInfo] = useState<{
        accountId: string;
        masterPassword: string;
        readOnlyPassword: string;
        platform: string;
    }>(
        {
            accountId: '-----',
            masterPassword: '?',
            readOnlyPassword: '?',
            platform: '?'
        }
    )

    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error("Lỗi khi copy:", err);
        }
    };

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const info = userData.find((user) => user.accountId === accountId);
                if (!info) {
                    console.error('User not found');
                    return;
                }
                setUserInfo(info);
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };
        fetchUserData();
    }, [accountId]);

    return (
        <>
            <div
                data-sentry-element="ContentElement"
                data-sentry-source-file="Modal.tsx"
                role="dialog"
                id="radix-«ra»"
                aria-describedby="radix-«rc»"
                aria-labelledby="radix-«rb»"
                data-state="open"
                className="flex cursor-default flex-col rounded-[4px] bg-background-secondary data-[state=open]:animate-contentShow center-x center-y fixed max-h-[85vh] w-[100vw] max-w-[352px] focus:outline-none sm:w-[90vw] sm:max-w-[688px] _content_aboc3_3"
                style={{ pointerEvents: 'auto' }}
            >
                <div className="flex items-baseline justify-between px-4 pt-3">
                    <h2 id="radix-«rb»" className="m-0 break-words text-headings-h5 text-content-primary">{t('LoginCredentials')}</h2>
                    <div className="flex-grow"></div>
                    <div className="_container_4x09j_3 group-hover:bg-background-hover group-active:bg-background-primary">
                        <button type="button" className="_button_4x09j_27 _size-large_4x09j_57 _kind-without-border_4x09j_75 text-content-tertiary" onClick={() => setIsShowModalCredentials(false)}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.72477 1L1.05505 2.66972L10.3578 11.9725L1 21.3486L2.65138 23L12.0275 13.6422L21.3853 23L23.055 21.3303L13.6972 11.9725L23 2.66972L21.3303 1L12.0275 10.3028L2.72477 1Z" fill="currentColor"></path>
                            </svg>
                        </button>
                    </div>
                </div>
                <div className="h-px bg-separators-primary mt-3" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
                <div className="px-4 sm:px-[24px] md:px-[32px] flex-basis-0 flex h-min min-h-0 flex-shrink flex-grow flex-col overflow-auto pb-4 pt-3">
                    <span
                        style={{
                            position: 'absolute',
                            border: 0,
                            width: '1px',
                            height: '1px',
                            padding: 0,
                            margin: '-1px',
                            overflow: 'hidden',
                            clip: 'rect(0px, 0px, 0px, 0px)',
                            whiteSpace: 'nowrap',
                            overflowWrap: 'normal'
                        }}
                    >
                        <p id="radix-«rc»">Default modal description placeholder for accessibility</p>
                    </span>
                    <div className="grid gap-4">
                        <div className="grid grid-cols-[1.5fr_1.5fr_1fr] items-center gap-4 md:grid-cols-[1.5fr_1fr_1fr]" data-testid="credentials-container">
                            <div className="inline items-center text-body-small text-content-tertiary md:text-body-large">Login:</div>
                            <div className="items-center justify-end text-right text-body-small text-content-primary md:justify-start md:text-start md:text-body-large grid"><span className="_passwordText_193hu_3">{userInfo.accountId}</span></div>
                            <div className="grid min-h-[68px] items-center gap-1">
                                <div className="flex items-center justify-end gap-[8px]">
                                    <span className="text-labels-small text-content-tertiary">{t('Copy')}</span>
                                    {userInfo && <div className="_container_4x09j_3 group-hover:bg-background-hover group-active:bg-background-primary" onClick={() => copyToClipboard(userInfo.accountId)}>
                                        <button type="button" aria-label="copy-password" className="_button_4x09j_27 _size-large_4x09j_57 _kind-with-border_4x09j_71">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_6_2803)">
                                                    <path
                                                        d="M15.0061 24H1.22699C0.552147 24 0 23.4479 0 22.773V9.00614C0 8.33129 0.552147 7.77914 1.22699 7.77914H7.77914V1.22699C7.77914 0.552147 8.33129 0 9.00614 0H22.7853C23.4601 0 24.0123 0.552147 24.0123 1.22699V15.0061C24.0123 15.681 23.4601 16.2331 22.7853 16.2331H16.2331V22.7853C16.2331 23.4601 15.681 24 15.0061 24ZM2.45399 21.546H13.7791V14.9939C13.7791 14.319 14.3313 13.7669 15.0061 13.7669H21.5583V2.45399H10.2331V9.00614C10.2331 9.68098 9.68098 10.2331 9.00614 10.2331H2.45399V21.546Z"
                                                        fill="currentColor"
                                                    ></path>
                                                    <path
                                                        d="M15.0061 15.9264H9.0061C8.50303 15.9264 8.08585 15.5092 8.08585 15.0061V9.00613C8.08585 8.50307 8.50303 8.08589 9.0061 8.08589H15.0061C15.5092 8.08589 15.9263 8.50307 15.9263 9.00613V15.0061C15.9263 15.5092 15.5092 15.9264 15.0061 15.9264ZM9.92635 14.0859H14.0859V9.92638H9.92635V14.0859Z"
                                                        fill="currentColor"
                                                    ></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6_2803"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                                </defs>
                                            </svg>
                                        </button>
                                    </div>}
                                </div>
                            </div>
                            <div className="md:flex inline items-center text-body-small text-content-tertiary md:text-body-large">
                                {t('Masterpassword')}:
                                <span className="relative ml-1">
                                    <span data-state="closed" data-sentry-element="HoverCard.Trigger" data-sentry-source-file="Tooltip.tsx">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_17_307)">
                                                <path d="M13.2271 10.4172H10.7731V16.6748H13.2271V10.4172Z" fill="currentColor"></path>
                                                <path
                                                    d="M12.0001 8.55216C12.3191 8.55216 12.6381 8.41719 12.8712 8.19633C13.1044 7.9632 13.2271 7.65645 13.2271 7.32516C13.2271 7.00614 13.0921 6.68713 12.8712 6.454C12.4172 6.00001 11.5952 6.00001 11.1412 6.454C10.908 6.68713 10.7731 7.00614 10.7731 7.32516C10.7731 7.64418 10.908 7.9632 11.1289 8.19633C11.362 8.41719 11.681 8.55216 12.0001 8.55216Z"
                                                    fill="currentColor"
                                                ></path>
                                                <path
                                                    d="M12 0C5.3865 0 0 5.3865 0 12C0 18.6135 5.3865 24 12 24C18.6135 24 24 18.6135 24 12C24 5.3865 18.6258 0 12 0ZM12 21.546C6.7362 21.546 2.45399 17.2638 2.45399 12C2.45399 6.7362 6.7362 2.45399 12 2.45399C17.2638 2.45399 21.546 6.7362 21.546 12C21.546 17.2638 17.2638 21.546 12 21.546Z"
                                                    fill="currentColor"
                                                ></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_17_307"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                </span>
                            </div>
                            <div className="flex items-center justify-end text-right text-body-small text-content-primary md:justify-start md:text-start md:text-body-large">
                                <div className="contents text-right md:text-start">
                                    <div className="flex justify-end md:justify-start">
                                        {isShowPassword ? userInfo.masterPassword : '●●●●●●●●●●'}
                                        <span className="ml-1 hover:cursor-pointer" style={{ display: 'flex', alignItems: 'center' }} onClick={() => setIsShowPassword(!isShowPassword)}>
                                            {isShowPassword
                                                ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M20.0435 16.6742C21.1317 15.6037 22.144 14.1818 22.9285 12.3023C23.0129 12.1062 23.0129 11.8856 22.9285 11.6895C19.8073 4.21246 13.084 4 12.3248 4C11.8186 4 8.59617 4.10623 5.59304 6.45965L2.34527 4.16343C1.96566 3.90194 1.44264 3.97549 1.16426 4.34321C0.885883 4.71093 0.970242 5.21757 1.34985 5.48723L4.34455 7.60368C3.35756 8.64147 2.43806 9.96527 1.71259 11.6977C1.62823 11.8938 1.62823 12.1144 1.71259 12.3105C4.83382 19.7794 11.5656 20 12.3248 20C12.814 20 15.8256 19.8938 18.736 17.7773L21.6547 19.8366C21.8066 19.9428 21.9753 19.9918 22.1524 19.9918C22.4139 19.9918 22.667 19.8774 22.8357 19.6568C23.1141 19.2891 23.0298 18.7824 22.6502 18.5128L20.0435 16.6742ZM12.3248 5.63432C12.9575 5.63432 18.4829 5.8141 21.2329 11.9918C20.5159 13.5935 19.6133 14.7947 18.6516 15.6854L15.7244 13.618C15.9775 13.1113 16.1293 12.5557 16.1293 11.9918C16.1293 9.9571 14.4168 8.29826 12.3163 8.29826C11.3125 8.29826 10.3677 8.68233 9.66751 9.33606L7.01025 7.45659C9.44818 5.72421 11.9114 5.63432 12.3248 5.63432ZM14.3409 12.6374L11.0847 10.333C11.439 10.0797 11.8692 9.92441 12.3248 9.92441C13.4973 9.92441 14.4506 10.8478 14.4506 11.9837C14.4506 12.2125 14.4084 12.4331 14.3409 12.6374ZM12.3248 18.3493C11.6921 18.3493 6.16667 18.1696 3.41661 11.9918C4.06617 10.5373 4.86756 9.42595 5.71958 8.56793L17.3103 16.764C14.982 18.284 12.7128 18.3493 12.3248 18.3493Z"
                                                        fill="currentColor"
                                                    ></path>
                                                </svg>
                                                : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_22_199)">
                                                        <path
                                                            d="M12.0011 7.99408C9.6303 7.99408 7.71472 9.92145 7.71472 12.2856C7.71472 14.6497 9.63978 16.5771 12.0011 16.5771C14.3623 16.5771 16.2874 14.6497 16.2874 12.2856C16.2874 9.92145 14.3623 7.99408 12.0011 7.99408ZM12.0011 14.6877C10.6829 14.6877 9.61133 13.6148 9.61133 12.2951C9.61133 10.9753 10.6829 9.90246 12.0011 9.90246C13.3192 9.90246 14.3908 10.9753 14.3908 12.2951C14.3908 13.6148 13.3192 14.6877 12.0011 14.6877Z"
                                                            fill="currentColor"
                                                        ></path>
                                                        <path
                                                            d="M21.721 16.5106C22.546 15.4567 23.2952 14.1845 23.921 12.6464C24.0159 12.4185 24.0159 12.1621 23.921 11.9343C23.2952 10.3867 22.5365 9.12392 21.721 8.07004L23.7409 5.86732C24.0917 5.47805 24.0728 4.8799 23.684 4.52861C23.2952 4.17731 22.6977 4.1963 22.3468 4.58557L20.4502 6.64587C16.8561 3.15191 12.6267 3 12.0008 3C11.3749 3 7.14549 3.15191 3.54193 6.64587L1.64531 4.58557C1.29444 4.1963 0.697005 4.16782 0.3082 4.51911C-0.0806061 4.87041 -0.0995722 5.47805 0.251301 5.85783L2.27119 8.06054C1.45565 9.12392 0.697005 10.3867 0.071123 11.9343C-0.0237077 12.1621 -0.0237077 12.4185 0.071123 12.6464C0.697005 14.194 1.45565 15.4567 2.27119 16.5106L0.251301 18.7133C-0.0995722 19.1026 -0.0806061 19.7007 0.3082 20.052C0.488378 20.2229 0.715972 20.2989 0.953048 20.2989C1.20909 20.2989 1.46513 20.1945 1.6548 19.9951L3.55141 17.9348C7.14549 21.4287 11.3844 21.5806 12.0008 21.5806C12.6172 21.5806 16.8561 21.4287 20.4502 17.9348L22.3468 19.9951C22.5365 20.1945 22.7925 20.2989 23.0486 20.2989C23.2762 20.2989 23.5038 20.2134 23.6934 20.052C24.0822 19.7007 24.1012 19.0931 23.7503 18.7133L21.721 16.5106ZM12.0008 19.6723C11.2896 19.6723 5.07818 19.4634 1.9867 12.2856C5.07818 5.10777 11.2896 4.89889 12.0008 4.89889C12.7121 4.89889 18.9235 5.10777 22.0149 12.2856C18.914 19.4634 12.7121 19.6723 12.0008 19.6723Z"
                                                            fill="currentColor"
                                                        ></path>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_22_199"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                                    </defs>
                                                </svg>
                                            }
                                        </span>
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                            <div className="grid min-h-[68px] items-center gap-1">
                                <div className="flex items-center justify-end gap-[8px]">
                                    <span className="text-labels-small text-content-tertiary">{t('Copy')}</span>
                                    {userInfo && <div className="_container_4x09j_3 group-hover:bg-background-hover group-active:bg-background-primary" onClick={() => copyToClipboard(userInfo.masterPassword)}>
                                        <button type="button" className="_button_4x09j_27 _size-large_4x09j_57 _kind-with-border_4x09j_71">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_6_2803)">
                                                    <path
                                                        d="M15.0061 24H1.22699C0.552147 24 0 23.4479 0 22.773V9.00614C0 8.33129 0.552147 7.77914 1.22699 7.77914H7.77914V1.22699C7.77914 0.552147 8.33129 0 9.00614 0H22.7853C23.4601 0 24.0123 0.552147 24.0123 1.22699V15.0061C24.0123 15.681 23.4601 16.2331 22.7853 16.2331H16.2331V22.7853C16.2331 23.4601 15.681 24 15.0061 24ZM2.45399 21.546H13.7791V14.9939C13.7791 14.319 14.3313 13.7669 15.0061 13.7669H21.5583V2.45399H10.2331V9.00614C10.2331 9.68098 9.68098 10.2331 9.00614 10.2331H2.45399V21.546Z"
                                                        fill="currentColor"
                                                    ></path>
                                                    <path
                                                        d="M15.0061 15.9264H9.0061C8.50303 15.9264 8.08585 15.5092 8.08585 15.0061V9.00613C8.08585 8.50307 8.50303 8.08589 9.0061 8.08589H15.0061C15.5092 8.08589 15.9263 8.50307 15.9263 9.00613V15.0061C15.9263 15.5092 15.5092 15.9264 15.0061 15.9264ZM9.92635 14.0859H14.0859V9.92638H9.92635V14.0859Z"
                                                        fill="currentColor"
                                                    ></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6_2803"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                                </defs>
                                            </svg>
                                        </button>
                                    </div>}
                                </div>
                                <div className="flex items-baseline justify-end gap-[8px]">
                                    <span className="text-labels-small text-content-tertiary">{t('change')}</span>
                                    <div className="_container_4x09j_3 group-hover:bg-background-hover group-active:bg-background-primary" onClick={() => handleShowModalChangePassword('master')}>
                                        <button type="button" className="_button_4x09j_27 _size-large_4x09j_57 _kind-with-border_4x09j_71">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_17_334)">
                                                    <path
                                                        d="M9.23676 12.6854L7.70405 7.23988C7.57944 6.80374 7.70405 6.34268 8.02804 6.0187L13.6978 0.348915C14.1713 -0.124606 14.9938 -0.124606 15.4548 0.348915L23.3302 8.2243C23.567 8.46106 23.6916 8.77259 23.6916 9.10904C23.6916 9.43303 23.5545 9.75702 23.3302 9.99378L17.6604 15.6636C17.4237 15.9003 17.0997 16.0249 16.7757 16.0249C16.6636 16.0249 16.5514 16.0125 16.4393 15.9751L11.0062 14.4424L7.00623 18.4424L8.3271 19.7632L6.57009 21.5203L5.23676 20.1994L4.52648 20.9097L5.84735 22.2305L4.09034 23.9875L1 20.9221L9.23676 12.6854ZM16.4143 13.3832L20.6885 9.10904L14.5826 2.99066L10.2959 7.2648L11.6417 12.0249L16.4143 13.3832Z"
                                                        fill="currentColor"
                                                    ></path>
                                                    <path
                                                        d="M15.3551 4.99689L18.6822 8.32399C19.0435 8.68536 19.0435 9.28349 18.6822 9.64486C18.4952 9.83178 18.2585 9.91901 18.0217 9.91901C17.785 9.91901 17.5482 9.83178 17.3613 9.64486L14.0342 6.31776C13.6728 5.95639 13.6728 5.35826 14.0342 4.99689C14.3956 4.63552 14.9937 4.62306 15.3551 4.99689Z"
                                                        fill="currentColor"
                                                    ></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_17_334"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                                </defs>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="md:flex inline items-center text-body-small text-content-tertiary md:text-body-large">
                                {t('Read-onlypassword')}:
                                <span className="relative ml-1">
                                    <span data-state="closed" data-sentry-element="HoverCard.Trigger" data-sentry-source-file="Tooltip.tsx">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_17_307)">
                                                <path d="M13.2271 10.4172H10.7731V16.6748H13.2271V10.4172Z" fill="currentColor"></path>
                                                <path
                                                    d="M12.0001 8.55216C12.3191 8.55216 12.6381 8.41719 12.8712 8.19633C13.1044 7.9632 13.2271 7.65645 13.2271 7.32516C13.2271 7.00614 13.0921 6.68713 12.8712 6.454C12.4172 6.00001 11.5952 6.00001 11.1412 6.454C10.908 6.68713 10.7731 7.00614 10.7731 7.32516C10.7731 7.64418 10.908 7.9632 11.1289 8.19633C11.362 8.41719 11.681 8.55216 12.0001 8.55216Z"
                                                    fill="currentColor"
                                                ></path>
                                                <path
                                                    d="M12 0C5.3865 0 0 5.3865 0 12C0 18.6135 5.3865 24 12 24C18.6135 24 24 18.6135 24 12C24 5.3865 18.6258 0 12 0ZM12 21.546C6.7362 21.546 2.45399 17.2638 2.45399 12C2.45399 6.7362 6.7362 2.45399 12 2.45399C17.2638 2.45399 21.546 6.7362 21.546 12C21.546 17.2638 17.2638 21.546 12 21.546Z"
                                                    fill="currentColor"
                                                ></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_17_307"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                </span>
                            </div>
                            <div className="items-center justify-end text-right text-body-small text-content-primary md:justify-start md:text-start md:text-body-large grid"><span className="_passwordText_193hu_3">{userInfo.readOnlyPassword}</span></div>
                            <div className="grid min-h-[68px] items-center gap-1">
                                <div className="flex items-center justify-end gap-[8px]">
                                    <span className="text-labels-small text-content-tertiary">{t('Copy')}</span>
                                    {userInfo && <div className="_container_4x09j_3 group-hover:bg-background-hover group-active:bg-background-primary" onClick={() => copyToClipboard(userInfo.readOnlyPassword)}>
                                        <button type="button" aria-label="copy-password" className="_button_4x09j_27 _size-large_4x09j_57 _kind-with-border_4x09j_71">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_6_2803)">
                                                    <path
                                                        d="M15.0061 24H1.22699C0.552147 24 0 23.4479 0 22.773V9.00614C0 8.33129 0.552147 7.77914 1.22699 7.77914H7.77914V1.22699C7.77914 0.552147 8.33129 0 9.00614 0H22.7853C23.4601 0 24.0123 0.552147 24.0123 1.22699V15.0061C24.0123 15.681 23.4601 16.2331 22.7853 16.2331H16.2331V22.7853C16.2331 23.4601 15.681 24 15.0061 24ZM2.45399 21.546H13.7791V14.9939C13.7791 14.319 14.3313 13.7669 15.0061 13.7669H21.5583V2.45399H10.2331V9.00614C10.2331 9.68098 9.68098 10.2331 9.00614 10.2331H2.45399V21.546Z"
                                                        fill="currentColor"
                                                    ></path>
                                                    <path
                                                        d="M15.0061 15.9264H9.0061C8.50303 15.9264 8.08585 15.5092 8.08585 15.0061V9.00613C8.08585 8.50307 8.50303 8.08589 9.0061 8.08589H15.0061C15.5092 8.08589 15.9263 8.50307 15.9263 9.00613V15.0061C15.9263 15.5092 15.5092 15.9264 15.0061 15.9264ZM9.92635 14.0859H14.0859V9.92638H9.92635V14.0859Z"
                                                        fill="currentColor"
                                                    ></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6_2803"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                                </defs>
                                            </svg>
                                        </button>
                                    </div>}
                                </div>
                                <div className="flex items-baseline justify-end gap-[8px]">
                                    <span className="text-labels-small text-content-tertiary">{t('change')}</span>
                                    <div
                                        className="_container_4x09j_3 group-hover:bg-background-hover group-active:bg-background-primary"
                                        onClick={() => handleShowModalChangePassword('read-only')}
                                    >
                                        <button type="button" className="_button_4x09j_27 _size-large_4x09j_57 _kind-with-border_4x09j_71">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_17_334)">
                                                    <path
                                                        d="M9.23676 12.6854L7.70405 7.23988C7.57944 6.80374 7.70405 6.34268 8.02804 6.0187L13.6978 0.348915C14.1713 -0.124606 14.9938 -0.124606 15.4548 0.348915L23.3302 8.2243C23.567 8.46106 23.6916 8.77259 23.6916 9.10904C23.6916 9.43303 23.5545 9.75702 23.3302 9.99378L17.6604 15.6636C17.4237 15.9003 17.0997 16.0249 16.7757 16.0249C16.6636 16.0249 16.5514 16.0125 16.4393 15.9751L11.0062 14.4424L7.00623 18.4424L8.3271 19.7632L6.57009 21.5203L5.23676 20.1994L4.52648 20.9097L5.84735 22.2305L4.09034 23.9875L1 20.9221L9.23676 12.6854ZM16.4143 13.3832L20.6885 9.10904L14.5826 2.99066L10.2959 7.2648L11.6417 12.0249L16.4143 13.3832Z"
                                                        fill="currentColor"
                                                    ></path>
                                                    <path
                                                        d="M15.3551 4.99689L18.6822 8.32399C19.0435 8.68536 19.0435 9.28349 18.6822 9.64486C18.4952 9.83178 18.2585 9.91901 18.0217 9.91901C17.785 9.91901 17.5482 9.83178 17.3613 9.64486L14.0342 6.31776C13.6728 5.95639 13.6728 5.35826 14.0342 4.99689C14.3956 4.63552 14.9937 4.62306 15.3551 4.99689Z"
                                                        fill="currentColor"
                                                    ></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_17_334"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                                </defs>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="inline items-center text-body-small text-content-tertiary md:text-body-large">Server:</div>
                            <div className="items-center justify-end text-right text-body-small text-content-primary md:justify-start md:text-start md:text-body-large grid"><span className="_passwordText_193hu_3">LUMIR-Demo</span></div>
                            <div className="grid min-h-[68px] items-center gap-1">
                                <div className="flex items-center justify-end gap-[8px]">
                                    <span className="text-labels-small text-content-tertiary">{t('Copy')}</span>
                                    <div className="_container_4x09j_3 group-hover:bg-background-hover group-active:bg-background-primary" onClick={() => copyToClipboard('LUMIR-Demo')}>
                                        <button type="button" aria-label="copy-password" className="_button_4x09j_27 _size-large_4x09j_57 _kind-with-border_4x09j_71">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_6_2803)">
                                                    <path
                                                        d="M15.0061 24H1.22699C0.552147 24 0 23.4479 0 22.773V9.00614C0 8.33129 0.552147 7.77914 1.22699 7.77914H7.77914V1.22699C7.77914 0.552147 8.33129 0 9.00614 0H22.7853C23.4601 0 24.0123 0.552147 24.0123 1.22699V15.0061C24.0123 15.681 23.4601 16.2331 22.7853 16.2331H16.2331V22.7853C16.2331 23.4601 15.681 24 15.0061 24ZM2.45399 21.546H13.7791V14.9939C13.7791 14.319 14.3313 13.7669 15.0061 13.7669H21.5583V2.45399H10.2331V9.00614C10.2331 9.68098 9.68098 10.2331 9.00614 10.2331H2.45399V21.546Z"
                                                        fill="currentColor"
                                                    ></path>
                                                    <path
                                                        d="M15.0061 15.9264H9.0061C8.50303 15.9264 8.08585 15.5092 8.08585 15.0061V9.00613C8.08585 8.50307 8.50303 8.08589 9.0061 8.08589H15.0061C15.5092 8.08589 15.9263 8.50307 15.9263 9.00613V15.0061C15.9263 15.5092 15.5092 15.9264 15.0061 15.9264ZM9.92635 14.0859H14.0859V9.92638H9.92635V14.0859Z"
                                                        fill="currentColor"
                                                    ></path>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_6_2803"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                                </defs>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="h-px bg-separators-primary" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
                        <h6 className="m-0 text-headings-h6 text-content-primary">Platform: MT5</h6>
                        <div>
                            <div className="mb-4 text-headings-headline text-content-tertiary md:mb-2">Web</div>
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="mr-[8px] text-content-tertiary">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_22_200)">
                                                <path
                                                    d="M19.589 18.5H4.40902C3.07902 18.5 1.99904 17.34 1.99904 15.93V4.58C1.99904 3.16 3.07902 2 4.40902 2H19.589C20.919 2 21.999 3.16 21.999 4.58V15.92C21.999 17.34 20.919 18.5 19.589 18.5ZM4.40902 4C4.21902 4 3.99905 4.24 3.99905 4.58V15.92C3.99905 16.26 4.21902 16.49 4.40902 16.49H19.589C19.779 16.49 19.999 16.25 19.999 15.92V4.58C19.999 4.24 19.779 4 19.589 4H4.40902Z"
                                                    fill="currentColor"
                                                ></path>
                                                <path d="M23 21.57H1C0.45 21.57 0 21.12 0 20.57C0 20.02 0.45 19.57 1 19.57H23C23.55 19.57 24 20.02 24 20.57C24 21.12 23.55 21.57 23 21.57Z" fill="currentColor"></path>
                                                <path
                                                    d="M6.36902 13.96C6.11902 13.96 5.87901 13.84 5.73901 13.61C5.51901 13.26 5.61899 12.8 5.96899 12.58C6.20899 12.43 6.90903 11.92 7.18903 11.45L7.24902 11.35C7.56902 10.8 8.09901 9.88995 9.04901 9.87995H9.05902C10.069 9.87995 10.729 10.98 10.949 11.35C11.349 12.01 11.599 12.25 11.719 12.33C11.819 12.2 12.059 11.82 12.299 10.72C12.699 8.89995 13.689 6.71995 15.149 6.56995C15.749 6.50995 16.619 6.75995 17.329 8.32996C17.559 8.82996 17.819 9.19996 18.109 9.42996C18.429 9.68996 18.489 10.16 18.229 10.48C17.969 10.8 17.499 10.86 17.179 10.6C16.699 10.22 16.289 9.65995 15.969 8.93995C15.629 8.18995 15.359 8.04995 15.309 8.04995C14.999 8.07995 14.189 9.13995 13.769 11.03C13.499 12.24 13.049 13.66 11.969 13.83C10.939 14 10.169 12.93 9.66901 12.11C9.26901 11.44 9.04901 11.37 9.04901 11.37C8.94901 11.43 8.66902 11.91 8.55902 12.1L8.48901 12.21C7.97901 13.08 6.909 13.77 6.789 13.85C6.649 13.92 6.50902 13.96 6.36902 13.96Z"
                                                    fill="currentColor"
                                                ></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_22_200"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                    <a className="text-body-small text-content-primary" href="https://lumir.finance" target="_blank" rel="noopener noreferrer">Open Web</a>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="mb-4 text-headings-headline text-content-tertiary md:mb-2">Desktop</div>
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="mr-[8px] text-content-tertiary">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_373_59)">
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M0.00749972 11.1989L0 3.39716L9.5999 2.09371V11.1989H0.00753722H0.00749972ZM11.1993 1.86118L23.9955 -0.0012207V11.1989H11.1992L11.1993 1.86118ZM23.9991 12.7987L23.9964 23.9988L11.1997 22.1984V12.7987H23.9991L23.9991 12.7987ZM9.599 21.9938L0.00708723 20.6783V12.7969H9.599V21.9938Z"
                                                    fill="currentColor"
                                                ></path>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_373_59"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                    <a className="text-body-small text-content-primary" href="https://download.mql5.com/cdn/web/ftmo.global.markets/mt5/ftmo5setup.exe" target="_blank" rel="noopener noreferrer">Download for Windows</a>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="mr-[8px] text-content-tertiary">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12.0547 5.53846C13.138 5.53846 14.4959 4.8061 15.3045 3.82962C16.0369 2.94469 16.5709 1.70884 16.5709 0.472982C16.5709 0.30515 16.5556 0.137317 16.5251 0C15.3198 0.0457724 13.8703 0.808646 13.0006 1.8309C12.3141 2.60903 11.6885 3.82963 11.6885 5.08074C11.6885 5.26383 11.719 5.44692 11.7343 5.50795C11.8106 5.5232 11.9326 5.53846 12.0547 5.53846ZM8.2403 24C9.72028 24 10.3764 23.0083 12.2225 23.0083C14.0992 23.0083 14.5111 23.9695 16.1589 23.9695C17.7762 23.9695 18.8595 22.4743 19.8818 21.0095C21.0261 19.3312 21.499 17.6834 21.5296 17.6071C21.4228 17.5766 18.3255 16.3102 18.3255 12.7552C18.3255 9.67324 20.7667 8.28481 20.904 8.178C19.2867 5.85887 16.8303 5.79784 16.1589 5.79784C14.3433 5.79784 12.8633 6.89638 11.9326 6.89638C10.9256 6.89638 9.59822 5.85887 8.0267 5.85887C5.03624 5.85887 2 8.33058 2 12.9994C2 15.8983 3.12905 18.965 4.51748 20.9485C5.70756 22.6268 6.74507 24 8.2403 24Z"
                                                fill="currentColor"
                                            ></path>
                                        </svg>
                                    </span>
                                    <a className="text-body-small text-content-primary" href="https://download.mql5.com/cdn/web/metaquotes.software.corp/mt5/MetaTrader5.pkg.zip" target="_blank" rel="noopener noreferrer">Download for MacOS</a>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="mb-4 text-headings-headline text-content-tertiary md:mb-2">Mobile</div>
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="mr-[8px] text-content-tertiary">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M4.94425 8.6032V18.8943H7.51219V22.1345C7.51219 22.9564 8.17793 23.6222 8.99993 23.6222C9.82193 23.6222 10.4877 22.9564 10.4877 22.1345V18.8943H12.5122V22.1345C12.5122 22.9564 13.1779 23.6222 14 23.6222C14.8219 23.6222 15.4877 22.9564 15.4877 22.1345V18.8943H18.0557V8.6032H4.94425Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                d="M2.98777 7.61133C2.16576 7.61133 1.5 8.277 1.5 9.09893V15.1683C1.5 15.9903 2.16576 16.6559 2.98777 16.6559C3.80979 16.6559 4.47554 15.9903 4.47554 15.1683V9.09893C4.47554 8.277 3.80979 7.61133 2.98777 7.61133Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                d="M20.0123 7.61133C19.1903 7.61133 18.5245 8.277 18.5245 9.09893V15.1683C18.5245 15.9903 19.1903 16.6559 20.0123 16.6559C20.8343 16.6559 21.5 15.9903 21.5 15.1683V9.09893C21.5 8.277 20.8343 7.61133 20.0123 7.61133Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                d="M15.104 2.28239L16.1094 0.540031L15.1753 0L14.1495 1.77293C13.3377 1.4231 12.4443 1.22951 11.5001 1.22951C10.5557 1.22951 9.659 1.42649 8.85053 1.77293L7.82475 0L6.88725 0.540031L7.89269 2.28239C6.11619 3.42359 4.94092 5.38332 4.94092 7.6114H18.0523C18.0557 5.38332 16.8839 3.42359 15.104 2.28239ZM8.56187 5.11841C8.195 5.11841 7.89948 4.82291 7.89948 4.4561C7.89948 4.08929 8.195 3.7938 8.56187 3.7938C8.92867 3.7938 9.2242 4.08929 9.2242 4.4561C9.2242 4.82291 8.92867 5.11841 8.56187 5.11841ZM14.4382 5.11841C14.0714 5.11841 13.7759 4.82291 13.7759 4.4561C13.7759 4.08929 14.0714 3.7938 14.4382 3.7938C14.8051 3.7938 15.1006 4.08929 15.1006 4.4561C15.1006 4.82291 14.8017 5.11841 14.4382 5.11841Z"
                                                fill="currentColor"
                                            ></path>
                                        </svg>
                                    </span>
                                    <a
                                        className="text-body-small text-content-primary"
                                        href="https://download.mql5.com/cdn/mobile/mt5/android?server=FTMO-Demo,FTMO-Demo2,FTMO-Server,FTMO-Server2,FTMO-Server3,FTMO-Server4,FTMO-Server5"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Download for Android
                                    </a>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="mr-[8px] text-content-tertiary">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12.0547 5.53846C13.138 5.53846 14.4959 4.8061 15.3045 3.82962C16.0369 2.94469 16.5709 1.70884 16.5709 0.472982C16.5709 0.30515 16.5556 0.137317 16.5251 0C15.3198 0.0457724 13.8703 0.808646 13.0006 1.8309C12.3141 2.60903 11.6885 3.82963 11.6885 5.08074C11.6885 5.26383 11.719 5.44692 11.7343 5.50795C11.8106 5.5232 11.9326 5.53846 12.0547 5.53846ZM8.2403 24C9.72028 24 10.3764 23.0083 12.2225 23.0083C14.0992 23.0083 14.5111 23.9695 16.1589 23.9695C17.7762 23.9695 18.8595 22.4743 19.8818 21.0095C21.0261 19.3312 21.499 17.6834 21.5296 17.6071C21.4228 17.5766 18.3255 16.3102 18.3255 12.7552C18.3255 9.67324 20.7667 8.28481 20.904 8.178C19.2867 5.85887 16.8303 5.79784 16.1589 5.79784C14.3433 5.79784 12.8633 6.89638 11.9326 6.89638C10.9256 6.89638 9.59822 5.85887 8.0267 5.85887C5.03624 5.85887 2 8.33058 2 12.9994C2 15.8983 3.12905 18.965 4.51748 20.9485C5.70756 22.6268 6.74507 24 8.2403 24Z"
                                                fill="currentColor"
                                            ></path>
                                        </svg>
                                    </span>
                                    <a
                                        className="text-body-small text-content-primary"
                                        href="https://download.mql5.com/cdn/mobile/mt5/ios?server=FTMO-Demo,FTMO-Demo2,FTMO-Server,FTMO-Server2,FTMO-Server3,FTMO-Server4,FTMO-Server5"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Download for iOS
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div role="alert" className="_alertBox_1mkfq_44 _infoAlert_1mkfq_21 mt-4" data-sentry-component="Alert" data-sentry-source-file="Alert.tsx">
                            <div className="flex flex-col items-start gap-[8px] md:flex-row md:items-center md:justify-between md:gap-4">
                                <div className="flex items-start gap-[8px]">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="size-4 flex-shrink-0">
                                        <g clip-path="url(#clip0_17_311)">
                                            <path d="M12.6308 4.98669H10.2249V11.2508H12.6308V4.98669Z" fill="currentColor"></path>
                                            <path
                                                d="M10.5738 13.4862C10.3452 13.7073 10.2249 14.0266 10.2249 14.3582C10.2249 14.6776 10.3572 14.9969 10.5738 15.2303C10.8023 15.4637 11.103 15.5865 11.4278 15.5865C11.7406 15.5865 12.0534 15.4514 12.2819 15.2303C12.5105 14.9969 12.6308 14.6899 12.6308 14.3582C12.6308 14.0389 12.4984 13.7195 12.2819 13.4862C11.8368 13.0194 11.0309 13.0194 10.5738 13.4862Z"
                                                fill="currentColor"
                                            ></path>
                                            <path
                                                d="M22.8556 3.68475C22.8556 1.65814 21.2317 0 19.2469 0H3.60879C1.62395 0 0 1.65814 0 3.68475V22.7717C0 23.2631 0.288703 23.7175 0.745816 23.9017C0.890167 23.9632 1.04655 24 1.20293 24C1.51569 24 1.81642 23.8772 2.04498 23.6438L5.49738 20.1556H19.3912C21.376 20.1556 23 18.4974 23 16.4585L22.8556 3.68475ZM19.3912 17.6991H5.00418C4.69142 17.6991 4.37866 17.8219 4.16213 18.0553L2.40586 19.8239V3.68475C2.40586 3.00921 2.94718 2.4565 3.60879 2.4565H19.2469C19.9085 2.4565 20.4498 3.00921 20.4498 3.69703L20.5941 16.4708C20.5941 17.1464 20.0528 17.6991 19.3912 17.6991Z"
                                                fill="currentColor"
                                            ></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_17_311"><rect width="24" height="24" fill="currentColor"></rect></clipPath>
                                        </defs>
                                    </svg>
                                    <span className="text-headings-headline">We recommend using the desktop platform as the webtrader does not store history.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                showPassworldChanger && (
                    <PassWordChange
                        accountId={accountId}
                        type={typeSelected}
                        onBack={() => setShowPassworldChanger(false)}
                        onSave={(value: string) => {
                            onSave(value);
                            setShowPassworldChanger(false);
                        }}
                    />
                )
            }
        </>
    )
}

export default CredentialsModal;

const PassWordChange = ({ accountId, type, onBack, onSave }: { accountId: string, type: 'read-only' | 'master', onBack: () => void, onSave: (value: string) => void }) => {
    const { t } = useTranslation();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    return (
        <form
            id="radix-«rc»"
            aria-describedby="radix-«re»"
            aria-labelledby="radix-«rd»"
            data-state="open"
            className="flex cursor-default flex-col rounded-[4px] bg-background-secondary data-[state=open]:animate-contentShow center-x center-y fixed max-h-[85vh] w-[100vw] max-w-[352px] focus:outline-none sm:w-[90vw] sm:max-w-[768px] _content_aboc3_3"
            data-test-id="passwordChangeModal"
            style={{ pointerEvents: 'auto' }}
        >
            <div className="flex items-baseline justify-between px-4 pt-3">
                <h2 id="radix-«rd»" className="m-0 break-words text-headings-h5 text-content-primary">{type.charAt(0).toUpperCase() + type.slice(1)}  {t('passwordchange')}</h2>
                <div className="flex-grow"></div>
                <div className="_container_4x09j_3 group-hover:bg-background-hover group-active:bg-background-primary">
                    <button type="button" className="_button_4x09j_27 _size-large_4x09j_57 _kind-without-border_4x09j_75 text-content-tertiary"
                        onClick={() => onBack()} aria-label="close-modal" data-sentry-component="CloseButton" data-sentry-source-file="CloseButton.tsx"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.72477 1L1.05505 2.66972L10.3578 11.9725L1 21.3486L2.65138 23L12.0275 13.6422L21.3853 23L23.055 21.3303L13.6972 11.9725L23 2.66972L21.3303 1L12.0275 10.3028L2.72477 1Z" fill="currentColor"></path>
                        </svg>
                    </button>
                </div>
            </div>
            <div className="h-px bg-separators-primary mt-3" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
            <div className="px-4 sm:px-[24px] md:px-[32px] lg:px-[40px] flex-basis-0 flex h-min min-h-0 flex-shrink flex-grow flex-col overflow-auto pb-4 pt-3">
                <span style={{
                    position: 'absolute',
                    border: 0,
                    width: '1px',
                    height: '1px',
                    padding: 0,
                    margin: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0px, 0px, 0px, 0px)',
                    whiteSpace: 'nowrap',
                    overflowWrap: 'normal'
                }}>
                    <p id="radix-«re»">Default modal description placeholder for accessibility</p>
                </span>
                <div className="grid gap-2">
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{type.charAt(0).toUpperCase() + type.slice(1)}  {t('Passwords')}</span></div>
                        <div className="group transition-all duration-150 rounded focus-within:bg-transparent group relative flex w-full border border-solid border-border-secondary bg-background-tertiary focus-within:border-functional-active">
                            <input
                                type="password"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="_small_fzuuo_13 max-h-[300px] w-full rounded border-none bg-transparent text-labels-medium text-content-primary caret-content-active placeholder:text-content-primary focus:text-content-secondary !overflow-x-hidden"
                                autoComplete="new-password"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t('Verifypassword')}</span></div>
                        <div className="group transition-all duration-150 rounded focus-within:bg-transparent group relative flex w-full border border-solid border-border-secondary bg-background-tertiary focus-within:border-functional-active">
                            <input
                                type="password"
                                name="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="_small_fzuuo_13 max-h-[300px] w-full rounded border-none bg-transparent text-labels-medium text-content-primary caret-content-active placeholder:text-content-primary focus:text-content-secondary !overflow-x-hidden"
                                autoComplete="new-password"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-px bg-separators-primary" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
            <div className="px-4 sm:px-[24px] md:px-[32px] lg:px-[40px] flex flex-col items-stretch justify-end gap-2 pb-4 pt-3 sm:flex-row">
                <div className="flex flex-col items-stretch gap-2 sm:flex-row sm:justify-end">
                    <button type="button" className="_button_rcmwj_3 _size-large_rcmwj_242 _type-secondary_rcmwj_71 _kind-filled_rcmwj_31 w-full md:w-auto" onClick={() => onBack()}>{t("Back")}</button>
                    <button type="submit" className="_button_rcmwj_3 _size-large_rcmwj_242 _type-primary_rcmwj_31 _kind-filled_rcmwj_31 w-full md:w-auto" onClick={() => onSave(password)}>{t("Save")}</button>
                </div>
            </div>
        </form>
    )
}

export const NewAccountCredentials = ({ onClose, onSave }: {
    onClose: () => void,
    onSave: (
        value: { accountId: string, nickName: string, balanceSize: number, platform: string, broker: string, accountType?: string } | null
    ) => void
}) => {
    const [nickname, setNickname] = useState('');
    const [accountId, setAccountId] = useState('');
    const [balanceSize, setBalanceSize] = useState('');
    const [platform, setPlatform] = useState('');
    const [broker, setBroker] = useState('');
    const [accountType, setAccountType] = useState('');
    const { t } = useTranslation();
    const [eror, setError] = useState([
        { field: 'accountId', message: '', error: false },
        { field: 'nickname', message: '', error: false },
        { field: 'balanceSize', message: '', error: false },
        { field: 'platform', message: '', error: false },
        { field: 'broker', message: '', error: false }
    ]);

    const [brokerList, setBrokerList] = useState<{ value: string, label: string }[]>([
        { value: "FTMO", label: "FTMO" },
        { value: "Ecmarkets", label: "EC Markets" },
        { value: "IC Markets", label: "IC Markets" },
    ]);

    const [accountSizeList, setAccountSizeList] = useState<{ value: string, label: string }[]>([
        { value: "10000", label: "10,000" },
        { value: "25000", label: "25,000" },
        { value: "50000", label: "50,000" },
        { value: "100000", label: "100,000" },
        { value: "200000", label: "200,000" },
    ]);

    async function checkData() {
        const errors = [];
        if (!accountId) {
            errors.push({ field: 'accountId', message: 'Account Number is required', error: true });
        }
        else {
            errors.push({ field: 'accountId', message: '', error: false });
        }
        if (!nickname) {
            errors.push({ field: 'nickname', message: 'Nickname is required', error: true });
        }
        else {
            errors.push({ field: 'nickname', message: '', error: false });
        }
        // if (!balanceSize || isNaN(Number(balanceSize)) || Number(balanceSize) <= 0) {
        //     errors.push({ field: 'balanceSize', message: 'Balance size must be a positive number', error: true });
        // }
        // else {
        //     errors.push({ field: 'balanceSize', message: '', error: false });
        // }
        if (!platform) {
            errors.push({ field: 'platform', message: 'Platform is required', error: true });
        }
        else {
            errors.push({ field: 'platform', message: '', error: false });
        }
        if (!broker) {
            errors.push({ field: 'broker', message: 'Broker is required', error: true });
        }
        else {
            errors.push({ field: 'broker', message: '', error: false });
        }
        setError(errors);
        if (errors.some(e => e.error)) {
            return false;
        }
        return true;
    }
    async function fetchBrokers() {
        try {
            const response = await mixGetV2('/terminal-accounts/brokers');
            const brokers = (response.data || []).map((value: string) => ({
                value: value,
                label: value
            }));

            if (brokers.length === 0) {
                console.error("Failed to fetch broker list:", response);
                setBrokerList([
                    { value: "FTMO", label: "FTMO" },
                    { value: "EC Trader", label: "EC Trader" },
                ]);
                return;
            }

            setBrokerList(brokers);

        } catch (error) {
            console.error('Error fetching brokers:', error);
        }
    }
    useEffect(() => {
        fetchBrokers();
    }, []);
    return (
        <div
            id="radix-«rc»"
            aria-describedby="radix-«re»"
            aria-labelledby="radix-«rd»"
            data-state="open"
            className="flex cursor-default flex-col rounded-[4px] bg-background-secondary data-[state=open]:animate-contentShow center-x center-y fixed max-h-[85vh] w-[100vw] max-w-[352px] focus:outline-none sm:w-[90vw] sm:max-w-[768px] _content_aboc3_3"
            style={{ pointerEvents: 'auto' }}
        >
            <div className="flex items-baseline justify-between px-4 pt-3">
                <h2 id="radix-«rd»" className="m-0 break-words text-headings-h5 text-content-primary">{t('NewAccount')}</h2>
                <div className="flex-grow"></div>
                <div className="_container_4x09j_3 group-hover:bg-background-hover group-active:bg-background-primary">
                    <button type="button" className="_button_4x09j_27 _size-large_4x09j_57 _kind-without-border_4x09j_75 text-content-tertiary" onClick={() => onClose()}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.72477 1L1.05505 2.66972L10.3578 11.9725L1 21.3486L2.65138 23L12.0275 13.6422L21.3853 23L23.055 21.3303L13.6972 11.9725L23 2.66972L21.3303 1L12.0275 10.3028L2.72477 1Z" fill="currentColor"></path>
                        </svg>
                    </button>
                </div>
            </div>
            <div className="h-px bg-separators-primary mt-3" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
            <div className="px-4 sm:px-[24px] md:px-[32px] lg:px-[40px] flex-basis-0 flex h-min min-h-0 flex-shrink flex-grow flex-col overflow-auto pb-4 pt-3">
                <div className="grid gap-2">
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t('AccountNumber')}</span></div>
                        <div className="group transition-all duration-150 rounded focus-within:bg-transparent group relative flex w-full border border-solid border-border-secondary bg-background-tertiary focus-within:border-functional-active">
                            <input
                                type="number"
                                name="accountId"
                                value={accountId}
                                onChange={(e) => setAccountId(e.target.value)}
                                className="_small_fzuuo_13 max-h-[300px] w-full rounded border-none bg-transparent text-labels-medium text-content-primary caret-content-active placeholder:text-content-primary focus:text-content-secondary !overflow-x-hidden"
                            />

                        </div>
                        {
                            eror.find(e => e.field === 'accountId')?.error && (
                                <div className="text-red-500 text-sm mt-1">
                                    {eror.find(e => e.field === 'accountId')?.message}
                                </div>
                            )
                        }
                    </div>
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t('NickName')}</span></div>
                        <div className="group transition-all duration-150 rounded focus-within:bg-transparent group relative flex w-full border border-solid border-border-secondary bg-background-tertiary focus-within:border-functional-active">
                            <input
                                type="text"
                                name="nickName"
                                value={nickname}
                                onChange={(e) => setNickname(e.target.value)}
                                className="_small_fzuuo_13 max-h-[300px] w-full rounded border-none bg-transparent text-labels-medium text-content-primary caret-content-active placeholder:text-content-primary focus:text-content-secondary !overflow-x-hidden"
                            />
                        </div>
                        {
                            eror.find(e => e.field === 'nickname')?.error && (
                                <div className="text-red-500 text-sm mt-1">
                                    {eror.find(e => e.field === 'nickname')?.message}
                                </div>
                            )
                        }
                    </div>
                    {/* <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">Init Balance</span></div>
                        <div className="group transition-all duration-150 rounded focus-within:bg-transparent group relative flex w-full border border-solid border-border-secondary bg-background-tertiary focus-within:border-functional-active">
                            <input
                                type="text"
                                name="balanceSize"
                                value={
                                    balanceSize
                                        ? balanceSize.replace(/^(\d+)(\.\d*)?$/, (_, intPart, decimalPart) =>
                                            intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (decimalPart || '')
                                        )
                                        : ''
                                }
                                onChange={(e) => {
                                    let raw = e.target.value.replace(/,/g, '');
                                    if (raw.indexOf('.') !== -1) {
                                        const firstDot = raw.indexOf('.');
                                        raw = raw.slice(0, firstDot + 1) + raw.slice(firstDot + 1).replace(/\./g, '');
                                    }
                                    setBalanceSize(raw);
                                }}
                                className="_small_fzuuo_13 lining-nums max-h-[300px] !normal-nums w-full rounded border-none bg-transparent text-labels-medium text-content-primary caret-content-active placeholder:text-content-primary focus:text-content-secondary !overflow-x-hidden"
                            />
                        </div>
                        {
                            eror.find(e => e.field === 'balanceSize')?.error && (
                                <div className="text-red-500 text-sm mt-1">
                                    {eror.find(e => e.field === 'balanceSize')?.message}
                                </div>
                            )
                        }
                    </div> */}
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t('Balance_Size')}</span></div>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        zIndexPopup: 2500,
                                        selectorBg: '#f0f0f0',
                                    },
                                },
                            }}
                        >

                            <Select
                                size="large"
                                style={{ width: '100%', zIndex: 2500 }}
                                className="[&_.ant-select-selector]:!bg-[#f0f0f0]"
                                value={balanceSize}
                                onChange={(value) => setBalanceSize(value)}
                                filterOption={(inputValue, option) =>
                                    option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                                options={[
                                    { value: '10000', label: '10,000' },
                                    { value: '25000', label: '25,000' },
                                    { value: '50000', label: '50,000' },
                                    { value: '100000', label: '100,000' },
                                    { value: '200000', label: '200,000' },
                                ]}
                            />
                            {eror.find(e => e.field === 'balanceSize')?.error && (
                                <div className="text-red-500 text-sm mt-1">
                                    {eror.find(e => e.field === 'balanceSize')?.message}
                                </div>
                            )}

                        </ConfigProvider>
                    </div>
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t('Platform')}</span></div>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        zIndexPopup: 2500,
                                    },
                                },
                            }}
                        >

                            <Select
                                size="large"
                                style={{
                                    zIndex: 2500,
                                }}
                                className="custom-select"
                                placeholder="Select a platform"
                                onChange={(value) => setPlatform(value)}
                                options={[
                                    { value: 'mt4', label: 'MT4' },
                                    { value: 'mt5', label: 'MT5' },
                                    { value: 'ctrader', label: 'cTrader' }
                                ]}
                                value={platform}
                            />
                            {eror.find(e => e.field === 'platform')?.error && (
                                <div className="text-red-500 text-sm mt-1">
                                    {eror.find(e => e.field === 'platform')?.message}
                                </div>
                            )}

                        </ConfigProvider>
                    </div>
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">Broker</span></div>

                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        zIndexPopup: 2500,
                                    },
                                },
                            }}
                        >
                            <Select
                                size="large"
                                className="custom-select"
                                placeholder="Select a broker"
                                onChange={(value) => setBroker(value)}
                                options={brokerList}
                                value={broker}
                            />
                            {
                                eror.find(e => e.field === 'broker')?.error && (
                                    <div className="text-red-500 text-sm mt-1">
                                        {eror.find(e => e.field === 'broker')?.message}
                                    </div>
                                )
                            }
                        </ConfigProvider>
                    </div>
                    {
                        broker === 'FTMO' && (
                            <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                                <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t("Account_Type")}</span></div>
                                <ConfigProvider
                                    theme={{
                                        components: {
                                            Select: {
                                                zIndexPopup: 2500,
                                            },
                                        },
                                    }}
                                >
                                    <Select
                                        size="large"
                                        className="custom-select"
                                        placeholder={t("Select_Account_Type")}
                                        onChange={(value) => setAccountType(value)}
                                        options={
                                            [
                                                { value: 'Challenge', label: 'Challenge' },
                                                { value: 'Verification', label: 'Verification' },
                                                { value: 'Funded', label: 'Funded' },
                                                { value: 'Demo', label: 'Demo' },
                                            ]
                                        }
                                        value={accountType}
                                    />
                                </ConfigProvider>
                            </div>
                        )
                    }
                </div>
            </div>
            <div className="h-px bg-separators-primary" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
            <div className="px-4 sm:px-[24px] md:px-[32px] lg:px-[40px] flex flex-col items-stretch justify-end gap-2 pb-4 pt-3 sm:flex-row">
                <div className="flex flex-col items-stretch gap-2 sm:flex-row sm:justify-end">
                    <button type="button" className="_button_rcmwj_3 _size-large_rcmwj_242 _type-secondary_rcmwj_71 _kind-filled_rcmwj_31 w-full md:w-auto" onClick={() => onClose()}>{t('Back')}</button>
                    <button type="submit" className="_button_rcmwj_3 _size-large_rcmwj_242 _type-primary_rcmwj_31 _kind-filled_rcmwj_31 w-full md:w-auto" onClick={() => {
                        checkData().then((isValid) => {
                            if (isValid) {
                                onSave({
                                    accountId: accountId,
                                    nickName: nickname,
                                    balanceSize: Number(balanceSize.replace(/,/g, '')),
                                    platform: platform,
                                    broker: broker,
                                    accountType: accountType
                                });
                            }
                        });
                    }}>{t('Save')}</button>
                </div>
            </div>
        </div>
    )
}

export const EditAccount = ({ onClose, onSave, account }: {
    onClose: () => void,
    onSave: (value: { accountId: number, nickName: string, balanceSize: number, platform: string, broker: string, accountType?: string }) => void,
    account: { accountId: number, account_number: string, nickName: string, balanceSize: number, platform: string, broker: string, accountType?: string }
}) => {
    const { t } = useTranslation();
    const [nickname, setNickname] = useState(account.nickName || '');
    const [accountId, setAccountId] = useState(account.account_number || '');
    const [balanceSize, setBalanceSize] = useState(account.balanceSize.toString() || '');
    const [platform, setPlatform] = useState(account.platform || '');
    const [broker, setBroker] = useState(account.broker || '');
    const [accountType, setAccountType] = useState(account.accountType || '');
    const [eror, setError] = useState([
        { field: 'accountId', message: '', error: false },
        { field: 'nickname', message: '', error: false },
        { field: 'balanceSize', message: '', error: false },
        { field: 'platform', message: '', error: false },
        { field: 'broker', message: '', error: false }
    ]);

    const [brokerList, setBrokerList] = useState<{ value: string, label: string }[]>([]);

    console.log(account);
    async function checkData() {
        const errors = [];
        if (!accountId) {
            errors.push({ field: 'accountId', message: 'Account Number is required', error: true });
        }
        else {
            errors.push({ field: 'accountId', message: '', error: false });
        }
        if (!nickname) {
            errors.push({ field: 'nickname', message: 'Nickname is required', error: true });
        }
        else {
            errors.push({ field: 'nickname', message: '', error: false });
        }
        // if (!balanceSize || isNaN(Number(balanceSize)) || Number(balanceSize) <= 0) {
        //     errors.push({ field: 'balanceSize', message: 'Balance size must be a positive number', error: true });
        // }
        // else {
        //     errors.push({ field: 'balanceSize', message: '', error: false });
        // }
        if (!platform) {
            errors.push({ field: 'platform', message: 'Platform is required', error: true });
        }
        else {
            errors.push({ field: 'platform', message: '', error: false });
        }
        if (!broker) {
            errors.push({ field: 'broker', message: 'Broker is required', error: true });
        }
        else {
            errors.push({ field: 'broker', message: '', error: false });
        }
        setError(errors);
        if (errors.some(e => e.error)) {
            return false;
        }
        return true;
    }
    async function fetchBrokers() {
        try {
            const response = await mixGetV2('/terminal-accounts/brokers');
            const brokers = (response.data || []).map((value: string) => ({
                value: value,
                label: value
            }));

            setBrokerList(brokers);
        } catch (error) {
            console.error('Error fetching brokers:', error);
        }
    }
    useEffect(() => {
        fetchBrokers();
    }, []);
    return (
        <div
        >

            <div className="h-px bg-separators-primary mt-3" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
            <div className="px-4 sm:px-[24px] md:px-[32px] lg:px-[40px] flex-basis-0 flex h-min min-h-0 flex-shrink flex-grow flex-col overflow-auto pb-4 pt-3">
                <div className="grid gap-2">
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t('AccountNumber')}</span></div>
                        <div className="group transition-all duration-150 rounded focus-within:bg-transparent group relative flex w-full border border-solid border-border-secondary bg-background-tertiary focus-within:border-functional-active">
                            <input
                                type="text"
                                name="accountId"
                                value={
                                    accountId
                                }
                                onChange={(e) => setAccountId(e.target.value)}
                                className="_small_fzuuo_13 max-h-[300px] w-full rounded border-none  text-labels-medium text-content-primary caret-content-active placeholder:text-content-primary focus:text-content-secondary !overflow-x-hidden"
                            />

                        </div>
                        {
                            eror.find(e => e.field === 'accountId')?.error && (
                                <div className="text-red-500 text-sm mt-1">
                                    {eror.find(e => e.field === 'accountId')?.message}
                                </div>
                            )
                        }
                    </div>
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t('NickName')}</span></div>
                        <div className="group transition-all duration-150 rounded focus-within:bg-transparent group relative flex w-full border border-solid border-border-secondary bg-background-tertiary focus-within:border-functional-active">
                            <input
                                type="text"
                                name="nickName"
                                value={nickname}
                                onChange={(e) => setNickname(e.target.value)}
                                className="_small_fzuuo_13 max-h-[300px] w-full rounded border-none bg-transparent text-labels-medium text-content-primary caret-content-active placeholder:text-content-primary focus:text-content-secondary !overflow-x-hidden"
                            />
                        </div>
                        {
                            eror.find(e => e.field === 'nickname')?.error && (
                                <div className="text-red-500 text-sm mt-1">
                                    {eror.find(e => e.field === 'nickname')?.message}
                                </div>
                            )
                        }
                    </div>
                    {/* <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t('Init_Balance')}</span></div>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        zIndexPopup: 2500,
                                        selectorBg: '#f0f0f0',
                                    },
                                },
                            }}
                        >
                            <AutoComplete
                                size="large"
                                style={{ width: '100%', zIndex: 2500 }}
                                className="[&_.ant-select-selector]:!bg-[#f0f0f0]"
                                value={balanceSize}
                                onChange={(value) => setBalanceSize(value)}
                                filterOption={(inputValue, option) =>
                                    option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                                options={[
                                    { value: '10000', label: '10,000' },
                                    { value: '25000', label: '25,000' },
                                    { value: '50000', label: '50,000' },
                                    { value: '100000', label: '100,000' },
                                    { value: '200000', label: '200,000' },
                                ]}
                            />
                            {eror?.find(e => e.field === 'balanceSize')?.error && (
                                <div className="text-red-500 text-sm mt-1">
                                    {eror.find(e => e.field === 'balanceSize')?.message}
                                </div>
                            )}
                        </ConfigProvider>
                    </div> */}
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t('Platform')}</span></div>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        zIndexPopup: 2500,
                                    },
                                },
                            }}
                        >

                            <Select
                                size="large"
                                style={{
                                    zIndex: 2500
                                }}
                                placeholder="Select a platform"
                                onChange={(value) => setPlatform(value)}
                                options={[
                                    { value: 'mt4', label: 'MT4' },
                                    { value: 'mt5', label: 'MT5' },
                                    { value: 'ctrader', label: 'cTrader' }
                                ]}
                                value={platform}
                            />
                            {eror.find(e => e.field === 'platform')?.error && (
                                <div className="text-red-500 text-sm mt-1">
                                    {eror.find(e => e.field === 'platform')?.message}
                                </div>
                            )}

                        </ConfigProvider>
                    </div>
                    <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                        <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">Broker</span></div>

                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        zIndexPopup: 2500,
                                    },
                                },
                            }}
                        >
                            <Select
                                size="large"
                                placeholder="Select a broker"
                                onChange={(value) => setBroker(value)}
                                options={brokerList}
                                value={broker}
                            />
                            {
                                eror.find(e => e.field === 'broker')?.error && (
                                    <div className="text-red-500 text-sm mt-1">
                                        {eror.find(e => e.field === 'broker')?.message}
                                    </div>
                                )
                            }
                        </ConfigProvider>
                    </div>
                    {
                        broker === 'FTMO' && (
                            <div className="flex flex-col gap-[8px]" data-sentry-component="FieldContainer" data-sentry-source-file="FieldContainer.tsx">
                                <div className="_sectionLabelContainer_8d9j0_14" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx"><span className="_sectionLabel_8d9j0_7">{t("Account_Type")}</span></div>
                                <ConfigProvider
                                    theme={{
                                        components: {
                                            Select: {
                                                zIndexPopup: 2500,
                                            },
                                        },
                                    }}
                                >
                                    <Select
                                        size="large"
                                        className="custom-select"
                                        placeholder={t("Select_Account_Type")}
                                        onChange={(value) => setAccountType(value)}
                                        options={
                                            [
                                                { value: 'challenge', label: 'Challenge' },
                                                { value: 'verification', label: 'Verification' },
                                                { value: 'funded', label: 'Funded' },
                                                { value: 'demo', label: 'Demo' }
                                            ]
                                        }
                                        value={accountType}
                                    />
                                </ConfigProvider>
                            </div>
                        )
                    }
                </div>
            </div>
            <div className="h-px bg-separators-primary" data-sentry-component="Separator" data-sentry-source-file="Separator.tsx"></div>
            <div className="px-4 sm:px-[24px] md:px-[32px] lg:px-[40px] flex flex-col items-stretch justify-end gap-2 pb-4 pt-3 sm:flex-row">
                <div className="flex flex-col items-stretch gap-2 sm:flex-row sm:justify-end">
                    <button type="button" className="_button_rcmwj_3 _size-large_rcmwj_242 _type-secondary_rcmwj_71 _kind-filled_rcmwj_31 w-full md:w-auto" onClick={() => onClose()}>{t('Back')}</button>
                    <button type="submit" className="_button_rcmwj_3 _size-large_rcmwj_242 _type-primary_rcmwj_31 _kind-filled_rcmwj_31 w-full md:w-auto" onClick={() => {
                        checkData().then((isValid) => {
                            if (isValid) {
                                onSave({
                                    accountId: account.accountId,
                                    nickName: nickname,
                                    balanceSize: Number(balanceSize.replace(/,/g, '')),
                                    platform: platform,
                                    broker: broker,
                                    accountType: accountType
                                });
                            }
                        });
                    }}>{t('Save')}</button>
                </div>
            </div>
        </div>
    )
}